'use client'

import Wallet from '@/utils/wallet'
import axios from 'axios'
import useSWR, { useSWRConfig } from 'swr'
import { STORAGE_TAPROOT_ADDRESS, FIREBASE_CF_SAVE_TOKEN_API_URL } from '@/utils/constants'
import jwtAndEncrypt from '@/utils/jwt-and-encrypt'
import { getFirebasePushToken } from '@/utils/firebase-messaging'

import SafeLocalStorage from '@/utils/safe-local-storage'

const KEY = '/is-logged-in'

const fetcher = () => {
	return Wallet.isSet()
}

const useLoggedIn = () => {
	const { data: loggedIn } = useSWR(KEY, fetcher)
	return loggedIn
}

const useLogout = () => {
	const { mutate } = useSWRConfig()
	const logout = () => {
		Wallet.delete()
		// Publish the signed-out state immediately. Revalidating after deleting
		// storage left one render where pages still believed a wallet existed.
		void mutate(KEY, false, { revalidate: false })
	}

	return logout
}

const useSignIn = () => {
	const { mutate } = useSWRConfig()
	const signIn = () => {
		Wallet.register()
		mutate(KEY)
	}

	return signIn
}

const saveFcmToken = () => {
	const isInStandaloneMode = 'standalone' in window.navigator && window.navigator?.standalone

	if (typeof Notification !== 'undefined' && isInStandaloneMode) {
		Notification.requestPermission()
			.then(async (permission) => {
				if (permission !== 'granted') return
				try {
					const currentToken = await getFirebasePushToken()
					if (!currentToken) return
					var walletAddress = SafeLocalStorage.getItem(STORAGE_TAPROOT_ADDRESS)
					var body = await jwtAndEncrypt(walletAddress, currentToken)
					await axios.post(`${FIREBASE_CF_SAVE_TOKEN_API_URL}`, body)
				} catch (e) {
					console.log(e)
				}
			})
			.catch((err) => {
				console.log(err)
			})
	}

	return null
}

export { useLoggedIn as default, useSignIn, useLogout, saveFcmToken }
